import React from "react";
import { MessageCircle, Send, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS, waLink } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#050912] border-t border-[rgba(46,155,255,0.14)] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <img src={BRAND.logo} alt="THE REAL ALGO" className="h-11 w-11 rounded-lg object-cover ring-1 ring-[rgba(46,155,255,0.4)]" />
              <span className="font-extrabold tracking-tight text-lg">THE REAL <span className="text-blue-grad">ALGO</span></span>
            </div>
            <p className="text-[#6fc3ff] text-sm font-semibold tracking-widest mt-3">{BRAND.tagline}</p>
            <p className="text-slate-400 text-sm mt-4 max-w-md leading-relaxed">The #1 gold scalping EA for XAUUSD on MT5 and a full-stack trading software development company. Trusted by 20,000+ traders worldwide.</p>
            <div className="flex gap-3 mt-6">
              <a href={waLink("Hi!")} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center rounded-full bg-[#0f1b30] border border-[rgba(46,155,255,0.25)] text-[#22e39a] hover:bg-[#132743] transition"><MessageCircle className="w-4 h-4" /></a>
              <a href={BRAND.telegram} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center rounded-full bg-[#0f1b30] border border-[rgba(46,155,255,0.25)] text-[#2e9bff] hover:bg-[#132743] transition"><Send className="w-4 h-4" /></a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold">Quick Links</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.label}><a href={l.href} className="text-slate-400 text-sm hover:text-[#6fc3ff] transition-colors">{l.label}</a></li>
              ))}
              <li><a href="#terms" className="text-slate-400 text-sm hover:text-[#6fc3ff] transition-colors">Terms & Conditions</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-[#22e39a]" /> {BRAND.whatsappDisplay}</li>
              <li className="flex items-center gap-2"><Send className="w-4 h-4 text-[#2e9bff]" /> @therealalgo</li>
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[#6fc3ff] mt-0.5" /> Available Worldwide</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/5 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs">© {new Date().getFullYear()} THE REAL ALGO. All rights reserved.</p>
          <p className="text-slate-600 text-[11px] max-w-xl text-center sm:text-right">Risk Warning: Trading involves significant risk. Past performance is not indicative of future results.</p>
        </div>
      </div>
    </footer>
  );
}
